import publicReq, { privateReq, imageReq } from './axiosConfig';


export const addOtherServicesApi = (data) => imageReq.post("/add-other-service", data);
export const getServiceProfile = () => privateReq.get('/get-service-profile');
export const getOtherServiceApi = (_id) => privateReq.get('/get-other-service/' + _id);
export const getAllOtherServicesApi = (data) => privateReq.get('/get-other-services' + data);
export const updateOtherServiceStatusApi = (data) => privateReq.post("/update-other-service-status", data);
